"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _scrollparent = _interopRequireDefault(require("scrollparent"));

var isInView = function isInView(element) {
  if (!element) {
    return false;
  }

  var elementRect = element.getBoundingClientRect();
  var container = (0, _scrollparent["default"])(element);

  if (container === document.documentElement) {
    return elementRect.top >= 0 && elementRect.left >= 0 && elementRect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && elementRect.right <= (window.innerWidth || document.documentElement.clientWidth);
  }

  var containerRect = container.getBoundingClientRect();
  return elementRect.top >= containerRect.top && elementRect.left >= containerRect.left && elementRect.bottom <= containerRect.bottom && elementRect.right <= containerRect.right;
};

var _default = isInView;
exports["default"] = _default;